import { Round } from "api";
import { DateTime } from "luxon";
import { useMemo } from "react";

export const LIMIT_OF_DAYS_TO_PROTEST = 3;

export const useIsValidRoundToProtest = (round: Round): boolean => {
    return useMemo(() => {
        const dateMinusLimitToProtest = DateTime.local()
            .minus({ day: LIMIT_OF_DAYS_TO_PROTEST })
            .toFormat("yyyy-MM-dd");

        if (dateMinusLimitToProtest > round.date) {
            return false;
        }
        return true;
    }, [round]);
};
